module.exports = __webpack_public_path__ + "static/media/Simbolo_Branco_Fundo_Preto.1f9ad8a3.png";